// export enum WORKFLOW_PHASE_TYPES {
//   FORM = 'FORM',
//   APPROVAL = 'APPROVAL',
//   NOTIFICATION = 'NOTIFICATION',
//   ACTION = 'ACTION',
//   STATUS_PRIMARY = 'STATUS-PRIMARY',
//   STATUS_SECONDARY = 'STATUS-SECONDARY',
//   STATUS_BASIC = 'STATUS-BASIC',
//   EXTERNAL_DATA_COLLECTION = 'EXTERNAL-DATA-COLLECTION',
// }

export enum WORKFLOW_INSTANCE_STATUS {
  DRAFT = 'draft',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  REJECTED = 'rejected',
  CANCELLED = 'cancelled',
}

export enum WORKFLOW_INSTANCE_PRIORITY {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  URGENT = 'urgent',
}

export enum WORKFLOW_STAGE_STATUS {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  REJECTED = 'rejected',
  SKIPPED = 'skipped',
}

export enum WORKFLOW_NODE_TYPES {
  FORM = 'form',
  STAGE = 'stage',
  STATUS = 'status',
  START = 'start',
  END = 'end',
  CUSTOM = 'custom',
  EXTERNAL_DATA_COLLECTION = 'external-data-collection',
  STATUS_PRIMARY = 'status-primary',
  STATUS_SECONDARY = 'status-secondary',
  STATUS_BASIC = 'status-basic',
}
